import BestDealIcon from "../../assets/icons/bestDeal.icon";
import CustomerCareIcon from "../../assets/icons/customerCare.icon";
import LocalIcon from "../../assets/icons/local.icon";
import RefundIcon from "../../assets/icons/refund.icon";
import ShopIcon from "../../assets/icons/shop.icon";

const aboutUsCardData = [
  {
    icon: <ShopIcon />,
    title: 'One stop ticket shop',
    desc: 'Plan, book and manage all your trips from your smartphone or laptop via our easy-to-use website. No need for multiple travel cards, station queues or paper tickets.',
    color: '#0064D9',
    bgColor: 'rgba(0, 100, 217, 0.3)'
  },
  {
    icon: <BestDealIcon />,
    title: 'The best deal every time',
    desc: 'We offer the same price as the Rail Carrier meaning cheap prices and no booking fees, what\'s not to love?',
    color: '#0fab6e',
    bgColor: 'rgba(15, 171, 110, 0.3)'
  },
  {
    icon: <CustomerCareIcon />,
    title: 'Great customer service',
    desc: 'Access friendly customer support whenever you need it. No bots. No long wait times. Just knowledgeable consultants ready to help.',
    color: '#E8B633',
    bgColor: 'rgba(232, 182, 51, 0.3)'
  },
  {
    icon: <RefundIcon />,
    title: 'Quick and simple refunds',
    desc: 'If your plans change, we offer quick and easy refunds. No need to jump through hoops.',
    color: '#EC4949',
    bgColor: 'rgba(236, 73, 73, 0.3)'
  }
]

export const staticContent = {
  AU: {
    heroTitle: 'Hop on and explore Europe.',
    heroSubTitle: 'Take the scenic route with terrific deals on train tickets.',
    aboutUsCardData: [...aboutUsCardData, {
      icon: <LocalIcon size={64} />,
      title: 'Aussie owned and operated',
      desc: 'We’re the brainchild of three Aussies with a bold vision – to use intuitive travel tech to make rail travel the number 1 choice for commuters and holidaymakers.',
      color: '#EC4949',
      bgColor: 'rgba(243, 154, 81, 0.3)'
    }],
  },
  UK: {
    heroTitle: 'Hop on and explore the UK',
    heroSubTitle: 'Take the scenic route with terrific deals on train tickets.',
    aboutUsCardData,
  },
  US: {
    heroTitle: 'Explore America.',
    heroSubTitle: 'Amtrak can take you to over 500 destinations, let us take you where you want to go!',
  },
  CA: {
    heroTitle: 'Explore Canada.',
    heroSubTitle: 'VIA Rail can take you where you want to go, you’ll love taking the train!',
  }
}